export const stringUtils = {
    unixTimeToDate,
    unixTimeToLocalDate,
    timeSince,
    timeSince_date,
    generateId,
    safeJSONparse
};

export function safeJSONparse(jsonString)
{
  try {
     return (JSON.parse(jsonString));
  }
  catch (e) {
    return undefined;
  }
}

export function generateId(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function timeSince_date(date) {

    var seconds = Math.floor((new Date() - date) / 1000);

    var interval = Math.floor(seconds / 31536000);

    var r_value = {};
    var isDone = false;

    r_value.seconds = seconds;
  
    if (interval > 1) {
      r_value.text = interval + " years";
      isDone= true;
    }
    interval = Math.floor(seconds / 2592000);
    if (!isDone && interval > 1) {
      r_value.text = interval + " months";
      isDone= true;
    }
    interval = Math.floor(seconds / 86400);
    if (!isDone && interval > 1) {
      r_value.text = interval + " days";
      isDone= true;
    }
    interval = Math.floor(seconds / 3600);
    if (!isDone && interval > 1) {
      r_value.text = interval + " hours";
      isDone= true;
    }
    interval = Math.floor(seconds / 60);
    if (!isDone && interval > 1) {
      r_value.text = interval + " minutes";
      isDone= true;
    }
    
    if (typeof(r_value.text)=='undefined')
      r_value.text = Math.floor(seconds) + " seconds";

    return r_value;
}
  
export function timeSince(unixtime)
{
    var dt = new Date(unixtime);
    return  timeSince_date(dt);
}

export function unixTimeToDate(unixtime,Timezone)
{
    var dt = new Date(unixtime);
    if (Timezone===undefined)
        Timezone = 'Etc/UTC';

    var options = { timeZone: Timezone, hour: '2-digit', minute:'2-digit', hour12: false };
    var val = dt.toLocaleDateString('en-EN',options);
    val = val.replace(',', '');
    return  val;
}

export function unixTimeToLocalDate(unixtime)
{
  var dt = new Date(unixtime);

  var options = {hour: '2-digit', minute:'2-digit', hour12: false };
  var val = dt.toLocaleDateString('en-EN',options);
  val = val.replace(',', '');
  return  val;
}
